export async function setTutorial(elType, intro) {
  await new Promise(resolve => setTimeout(resolve, 900));
  if (!elType) return;
  const isIntro = localStorage.getItem(elType);
  if (isIntro) return;

  const introJs = this.$intro();
  const element = document.querySelector("." + elType);

  if (!element) return;

  introJs.setOptions({
    exitOnOverlayClick: false,
    doneLabel: "הבנתי, סיים",
    nextLabel: "הבא",
    prevLabel: "הקודם",
    skipLabel: "דלג",
    steps: [
      {
        element,
        intro
      }
    ]
  });

  introJs.oncomplete(() => {
    localStorage.setItem(elType, true);
  });
  introJs.start();
}
